import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import {
  CheckCircle,
  AlertCircle,
  RefreshCw,
  Loader2,
  Home,
  ArrowRight,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setUser, updateSubscriptionData } from "../../../redux/userSlice";
import subscriptionRequests from "../../../api/Customer/SubscriptionRequests";

const PaymentVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [checking, setChecking] = useState(false);
  const [verificationResult, setVerificationResult] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const user = useSelector((state) => state.user?.txtconnect_ng_user);
  const referenceId =
    location.state?.referenceId ||
    sessionStorage.getItem("payment_reference") ||
    null;
  const paymentDetails = location.state?.paymentDetails || null;

  const network =
    paymentDetails?.network ||
    sessionStorage.getItem("payment_network") ||
    null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
// firssssttttt
  // const handlePaymentVerification = async () => {
  //   try {
  //     setChecking(true);
  //     setVerificationResult(null);
  //     let verificationResponse;
  //     let shouldFetchSubscription = false;

  //     if (referenceId) {
  //       if (!network) {
  //         const storedNetwork = sessionStorage.getItem("payment_network");
  //         if (!storedNetwork) {
  //           toast.error(
  //             "Network information is missing. Please return to subscription plans and try again."
  //           );
  //           setVerificationResult("error");
  //           setChecking(false);
  //           return;
  //         }
  //         const finalNetwork = storedNetwork;
  //         verificationResponse = await subscriptionRequests.VerifySubscription(
  //           finalNetwork,
  //           referenceId
  //         );
  //       } else {
  //         verificationResponse = await subscriptionRequests.VerifySubscription(
  //           network,
  //           referenceId
  //         );
  //       }

  //       if (verificationResponse.status_code === "000"||verificationResponse.data.status==="paid") {
  //         shouldFetchSubscription = true;
  //         //console.log("verication status isssss:",verificationResponse.data.status) ;
  //       }
  //     } else {
  //       shouldFetchSubscription = true;
  //     }

  //     if (shouldFetchSubscription) {
  //       const subscriptionResponse =
  //         await subscriptionRequests.getCurrentUserSubscriptionData();

  //       if (
  //         subscriptionResponse.status_code === "000" &&
  //         subscriptionResponse.data
  //       ) {
  //         const data = subscriptionResponse.data;
  //         setSubscriptionData(data);

  //         if (data.subscription_plan) {
  //           dispatch(
  //             updateSubscriptionData({
  //               subscriptionData: data.subscription_plan,
  //             })
  //           );
  //         }
  //         dispatch(
  //           setUser({
  //             userData: {
  //               ...user,
  //               units: data.units || user?.units,
  //               subscription_plan:
  //                 data.subscription_plan || user?.subscription_plan,
  //             },
  //             token: user?.token || null,
  //           })
  //         );
  //         sessionStorage.setItem("shouldRefreshSubscription", "true");
  //         sessionStorage.removeItem("payment_network");
  //         sessionStorage.removeItem("payment_reference");
  //         setVerificationResult("paid");
  //       } else {
  //         setVerificationResult("error");
  //       }
  //     } else {
  //       if (verificationResponse?.data) {
  //         let status = null;
  //         const data = verificationResponse.data;
  //         if (data.subscription_plan?.status) {
  //           status = data.subscription_plan.status.toLowerCase();
  //         } else if (data.status) {
  //           status = data.status.toLowerCase();
  //         }

  //         if (status === "pending" || status === "processing") {
  //           setVerificationResult("pending");
  //         } else {
  //           setVerificationResult("error");
  //         }
  //       } else {
  //         setVerificationResult("error");
  //       }
  //     }
  //   } catch (error) {
  //     setVerificationResult("error");
  //   } finally {
  //     setChecking(false);
  //   }
  // };

  const handlePaymentVerification = async () => {
  try {
    setChecking(true);
    setVerificationResult(null);
    let verificationResponse;
    let shouldFetchSubscription = false;

    // //console.log("Starting verification with:", { referenceId, network });

    if (referenceId) {
      if (!network) {
        const storedNetwork = sessionStorage.getItem("payment_network");
        if (!storedNetwork) {
          toast.error(
            "Network information is missing. Please return to subscription plans and try again."
          );
          setVerificationResult("error");
          setChecking(false);
          return;
        }
        const finalNetwork = storedNetwork;
        verificationResponse = await subscriptionRequests.VerifySubscription(
          finalNetwork,
          referenceId
        );
      } else {
        verificationResponse = await subscriptionRequests.VerifySubscription(
          network,
          referenceId
        );
      }

      // //console.log("=== VERIFICATION RESPONSE ===");
      // //console.log("Full object:", verificationResponse);
      // //console.log("Root status_code:", verificationResponse.status_code);
      // //console.log("data.status_code:", verificationResponse.data?.data?.status);
      // //console.log("data.in_error:", verificationResponse.data?.in_error);
      // //console.log("data.data:", verificationResponse.data?.data);
      // //console.log("data.status:", verificationResponse.data?.status);
      // //console.log("============================");

      // FIXED: Check multiple possible success indicators
      const isSuccess = verificationResponse.data?.status === "paid";

      if (isSuccess) {
        shouldFetchSubscription = true;
        // //console.log("✓ Should fetch subscription: YES");
      } else {
        // //console.log("✗ Should fetch subscription: NO");
        
        // Check if payment is still pending
        const paymentStatus = verificationResponse.data?.status?.toLowerCase();
        
        // //console.log("Payment status determined:", paymentStatus);
        
        if (paymentStatus === "pending" || paymentStatus === "processing") {
          setVerificationResult("pending");
          setChecking(false);
          return;
        }
        
        // If not pending and not success, show error
        setVerificationResult("error");
        setChecking(false);
        return;
      }
    } else {
      // //console.log("No referenceId, fetching subscription directly");
      shouldFetchSubscription = true;
    }

    if (shouldFetchSubscription) {
      // //console.log("=== FETCHING SUBSCRIPTION ===");
      const subscriptionResponse = await subscriptionRequests.getCurrentUserSubscriptionData();

      // //console.log("Subscription API response:", subscriptionResponse);
      // //console.log("Root status_code:", subscriptionResponse.status_code);
      // //console.log("data:", subscriptionResponse.data);
      // //console.log("Has data?:", !!subscriptionResponse.data);
      // //console.log("=============================");

      // FIXED: Check multiple possible success codes for subscription too
      const isSubscriptionSuccess = 
        subscriptionResponse.status_code === "000" ||
        subscriptionResponse.status_code === "200" ||
        (subscriptionResponse.data && !subscriptionResponse.in_error);

      if (isSubscriptionSuccess && subscriptionResponse.data) {
        const data = subscriptionResponse.data;
        // //console.log("✓ Subscription data received:", data);
        setSubscriptionData(data);

        if (data.subscription_plan) {
          dispatch(
            updateSubscriptionData({
              subscriptionData: data.subscription_plan,
            })
          );
        }
        dispatch(
          setUser({
            userData: {
              ...user,
              units: data.units || user?.units,
              subscription_plan: data.subscription_plan || user?.subscription_plan,
            },
            token: user?.token || null,
          })
        );
        sessionStorage.setItem("shouldRefreshSubscription", "true");
        sessionStorage.removeItem("payment_network");
        sessionStorage.removeItem("payment_reference");
        setVerificationResult("paid");
        // //console.log("✓ Verification result set to: paid");
      } else {
        // //console.log("✗ Subscription fetch failed or returned no data");
        // //console.log("Status code was:", subscriptionResponse.status_code);
        // //console.log("Data was:", subscriptionResponse.data);
        setVerificationResult("error");
      }
    }
  } catch (error) {
    console.error("❌ Verification error:", error);
    console.error("Error details:", error.response?.data || error.message);
    setVerificationResult("error");
  } finally {
    setChecking(false);
    // //console.log("Verification process completed");
  }
};
  const getStatusContent = () => {
    switch (verificationResult) {
      case "paid":
        return {
          icon: <CheckCircle className="w-16 h-16 text-green-500" />,
          title: "Payment Verified Successfully!",
          message:
            "Your subscription has been activated and you can now start using our services.",
          bgColor: "from-red-50 via-red-50 to-red-50",
          buttonText: "Go to Dashboard",
          buttonAction: () => navigate("/home"),
          showSecondButton: true,
          secondButtonText: "Send Your First SMS",
          secondButtonAction: () => navigate("/quick-sms"),
        };
      case "error":
        return {
          icon: <AlertCircle className="w-16 h-16 text-red-500" />,
          title: "Payment Verification Failed",
          message:
            "We couldn't verify your payment. Please contact our support team for assistance or try again.",
          bgColor: "from-red-50 via-pink-50 to-red-50",
          buttonText: "Try Again",
          buttonAction: handlePaymentVerification,
          showSecondButton: true,
          secondButtonText: "Back to Plans",
          secondButtonAction: () => navigate("/subscription-plans"),
        };
      case "pending":
        return {
          icon: <RefreshCw className="w-16 h-16 text-yellow-500" />,
          title: "Payment Still Processing",
          message:
            "Your payment is still being processed. This can take a few minutes. Please try again in a moment.",
          bgColor: "from-yellow-50 via-orange-50 to-yellow-50",
          buttonText: "Check Again",
          buttonAction: handlePaymentVerification,
          showSecondButton: true,
          secondButtonText: "Go to Dashboard",
          secondButtonAction: () => navigate("/home"),
        };
      default:
        return null;
    }
  };

  const statusContent = getStatusContent();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`pt-20 pb-8 min-h-screen bg-gradient-to-br ${
        statusContent
          ? statusContent.bgColor
          : "from-gray-50 via-blue-50 to-gray-50"
      }`}
    >
      <div className="px-4 mx-auto max-w-4xl sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-4 text-3xl font-bold text-gray-800"
          >
            Payment Verification
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-lg text-gray-600"
          >
            Let's verify your payment status
          </motion.p>
        </div>

        {/* Main Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="p-8 mb-8 bg-white rounded-2xl shadow-xl"
        >
          {!verificationResult ? (
            <div className="text-center">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
                className="flex justify-center items-center mx-auto mb-6 w-24 h-24 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full"
              >
                <RefreshCw className="w-12 h-12 text-white" />
              </motion.div>

              <h2 className="mb-4 text-2xl font-bold text-gray-800">
                Verify Your Payment
              </h2>

              <p className="mx-auto mb-4 max-w-md text-gray-600">
                Click the button below to check if your payment has been
                processed successfully.
              </p>

              {(referenceId || network) && (
                <div className="mx-auto mb-8 p-3 max-w-md space-y-2 text-sm text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
                  {referenceId && (
                    <div>
                      <span className="font-medium">Reference ID: </span>
                      <span className="font-mono">{referenceId}</span>
                    </div>
                  )}
                  {network && (
                    <div>
                      <span className="font-medium">Network: </span>
                      <span className="font-medium text-gray-700">
                        {network}
                      </span>
                    </div>
                  )}
                </div>
              )}

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handlePaymentVerification}
                disabled={checking}
                className="flex gap-2 justify-center items-center px-8 py-4 mx-auto font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {checking ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Checking Payment...
                  </>
                ) : (
                  <>
                    <RefreshCw className="w-5 h-5" />I Have Paid
                  </>
                )}
              </motion.button>
            </div>
          ) : (
            <div className="text-center">
              <AnimatePresence mode="wait">
                <motion.div
                  key={verificationResult}
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                  transition={{ type: "spring", stiffness: 200 }}
                  className="mb-6"
                >
                  {statusContent.icon}
                </motion.div>
              </AnimatePresence>

              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="mb-4 text-2xl font-bold text-gray-800"
              >
                {statusContent.title}
              </motion.h2>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="mx-auto mb-8 max-w-md text-gray-600"
              >
                {statusContent.message}
              </motion.p>

              {subscriptionData && verificationResult === "paid" && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="p-6 mb-8 bg-green-50 rounded-xl border border-green-200"
                >
                  <h3 className="mb-4 font-semibold text-gray-800">
                    Subscription Details
                  </h3>
                  <div className="grid grid-cols-1 gap-4 text-sm md:grid-cols-2">
                    <div>
                      <span className="font-semibold text-gray-700">Plan:</span>
                      <span className="ml-2 text-green-600">
                        {subscriptionData.data.subscription_plan?.name}
                      </span>
                    </div>
                    <div>
                      <span className="font-semibold text-gray-700">
                        Units:
                      </span>
                      <span className="ml-2 text-green-600">
                        {subscriptionData.data.subscription_plan?.units}
                      </span>
                    </div>
                    <div>
                      <span className="font-semibold text-gray-700">
                        Price:
                      </span>
                      <span className="ml-2 text-green-600">
                        GH₵{subscriptionData.data.subscription_plan?.price}
                      </span>
                    </div>
                    <div>
                      <span className="font-semibold text-gray-700">
                        Status:
                      </span>
                      <span className="px-2 py-1 ml-2 text-xs text-green-700 bg-green-100 rounded-full">
                        {subscriptionData.data.subscription_plan?.status}
                      </span>
                    </div>
                  </div>
                </motion.div>
              )}

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="flex flex-col gap-4 sm:flex-row sm:justify-center"
              >
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={statusContent.buttonAction}
                  className="flex gap-2 justify-center items-center px-8 py-4 font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl"
                >
                  {verificationResult === "paid" ? (
                    <Home className="w-5 h-5" />
                  ) : (
                    <RefreshCw className="w-5 h-5" />
                  )}
                  {statusContent.buttonText}
                </motion.button>

                {statusContent.showSecondButton && (
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={statusContent.secondButtonAction}
                    className="flex gap-2 justify-center items-center px-8 py-4 font-semibold text-blue-600 bg-white rounded-xl border-2 border-blue-600 transition-all duration-300 hover:bg-blue-50"
                  >
                    {verificationResult === "paid" ? (
                      <ArrowRight className="w-5 h-5" />
                    ) : (
                      <Home className="w-5 h-5" />
                    )}
                    {statusContent.secondButtonText}
                  </motion.button>
                )}
              </motion.div>
            </div>
          )}
        </motion.div>

        {/* Additional Info */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="p-6 bg-blue-50 rounded-xl border border-blue-200"
        >
          <div className="text-center">
            <h3 className="mb-2 font-semibold text-gray-800">
              Need Immediate Assistance?
            </h3>
            <p className="mb-4 text-sm text-gray-600">
              Our support team is available 24/7 to help you resolve any payment
              issues
            </p>
            <div className="flex flex-col gap-2 justify-center sm:flex-row">
              <button
                onClick={() =>
                  window.open("mailto:support@txtconnect.ng", "_blank")
                }
                className="font-medium text-blue-600 hover:text-blue-700"
              >
                Email Support
              </button>
              <span className="hidden text-gray-400 sm:inline">•</span>
              <button
                onClick={() => window.open("tel:+2331234567890", "_blank")}
                className="font-medium text-blue-600 hover:text-blue-700"
              >
                Call Support
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default PaymentVerification;
